import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

const DatabaseIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <ellipse
                cx="12"
                cy="6"
                rx="8"
                ry="3"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
            />

            <path
                d="M4 6v5.5c0 1.66 3.58 3 8 3s8-1.34 8-3V6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
            />
            <path
                d="M4 6v11c0 1.66 3.58 3 8 3s8-1.34 8-3V6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
            />
        </SvgIcon>
    )
}

export default DatabaseIcon
